module.exports = __webpack_public_path__ + "static/media/RoundedRect_Danger.b21e703f.png";